import { render, staticRenderFns } from "./subcontractor-settlement-modal.vue?vue&type=template&id=133481a7&scoped=true"
import script from "./subcontractor-settlement-modal.vue?vue&type=script&lang=js"
export * from "./subcontractor-settlement-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133481a7",
  null
  
)

export default component.exports